/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Wrapuptimeseconds3Inputs */

const en_entity_wrapuptimeseconds3 = /** @type {(inputs: Entity_Wrapuptimeseconds3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrap-up Time in Seconds`)
};

const de_entity_wrapuptimeseconds3 = /** @type {(inputs: Entity_Wrapuptimeseconds3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachbearbeitungszeit in Sekunden`)
};

/**
* | output |
* | --- |
* | "Wrap-up Time in Seconds" |
*
* @param {Entity_Wrapuptimeseconds3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_wrapuptimeseconds3 = /** @type {((inputs?: Entity_Wrapuptimeseconds3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Wrapuptimeseconds3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_wrapuptimeseconds3(inputs)
	return de_entity_wrapuptimeseconds3(inputs)
});
export { entity_wrapuptimeseconds3 as "entity_wrapUpTimeSeconds" }